import {
    ArrowDown,
    ArrowUp,
    DownloadSimple,
} from '@phosphor-icons/react'

import './SalesReportPage.scss'

const breakdown = [
    {
        date: 'Sun 4 May',
        orders: 56,
        revenue: 'RM5,234.00',
        avg: 'RM93.50',
    },
    {
        date: 'Sat 3 May',
        orders: 65,
        revenue: 'RM6,208.00',
        avg: 'RM97.00',
    },
    {
        date: 'Fri 2 May',
        orders: 48,
        revenue: 'RM5,234.00',
        avg: 'RM91.60',
    },
    {
        date: 'Thu 1 May',
        orders: 41,
        revenue: 'RM3,640.00',
        avg: 'RM88.80',
    },
    {
        date: 'Wed 30 Apr',
        orders: 37,
        revenue: 'RM2,997.00',
        avg: 'RM81.00',
    },
]

const topItems = [
    {
        rank: 1,
        name: 'Miso Ramen Noodle',
        category: 'Noodles',
        price: 'RM18.90',
        revenue: 'RM6,830.20',
        sold: '68 sold',
        image:
            'https://images.unsplash.com/photo-1557872943-16a5ac26437e?q=80&w=300',
    },
    {
        rank: 2,
        name: 'Chicken Katsu Don',
        category: 'Rice',
        price: 'RM22.90',
        revenue: 'RM4,282.70',
        sold: '53 sold',
        image:
            'https://images.unsplash.com/photo-1512058564366-18510be2db19?q=80&w=300',
    },
    {
        rank: 3,
        name: 'Beef Teppanyaki Set',
        category: 'Noodles',
        price: 'RM29.90',
        revenue: 'RM3,912.20',
        sold: '80 sold',
        image:
            'https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=300',
    },
    {
        rank: 4,
        name: 'Salmon Don (Salmon bowl)',
        category: 'Noodles',
        price: 'RM28.90',
        revenue: 'RM2,772.60',
        sold: '280 sold',
        image:
            'https://images.unsplash.com/photo-1565299507177-b0ac66763828?q=80&w=300',
    },
    {
        rank: 5,
        name: 'Chicken Katsu Curry',
        category: 'Noodles',
        price: 'RM28.90',
        revenue: 'RM2,268.60',
        sold: '236 sold',
        image:
            'https://images.unsplash.com/photo-1604908176997-4317dccf9c78?q=80&w=300',
    },
    {
        rank: 6,
        name: 'Mentai (Spicy cod roe) Ramen',
        category: 'Noodles',
        price: 'RM28.90',
        revenue: 'RM1,974.40',
        sold: '60 sold',
        image:
            'https://images.unsplash.com/photo-1617093727343-374698b1b08d?q=80&w=300',
    },
    {
        rank: 7,
        name: 'Udon with Tempura',
        category: 'Noodles',
        price: 'RM28.90',
        revenue: 'RM1,782.50',
        sold: '80 sold',
        image:
            'https://images.unsplash.com/photo-1618841557871-b4664fbf0cb3?q=80&w=300',
    },
    {
        rank: 8,
        name: 'Chicken Karaage Plate',
        category: 'Noodles',
        price: 'RM28.90',
        revenue: 'RM1,521.80',
        sold: '160 sold',
        image:
            'https://images.unsplash.com/photo-1608039829572-78524f79c4c7?q=80&w=300',
    },
    {
        rank: 9,
        name: 'Vegetable Tempura Set',
        category: 'Noodles',
        price: 'RM28.90',
        revenue: 'RM1,430.20',
        sold: '130 sold',
        image:
            'https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?q=80&w=300',
    },
    {
        rank: 10,
        name: 'Matcha Ice Cream Bowl',
        category: 'Dessert',
        price: 'RM28.90',
        revenue: 'RM1,260.00',
        sold: '100 sold',
        image:
            'https://images.unsplash.com/photo-1570197788417-0e82375c9371?q=80&w=300',
    },
]

export default function SalesReportPage() {
    return (
        <div className="sales-report-page">
            <div className="page-header">
                <div>
                    <div className="page-breadcrumb">
                        Hikaya House /{' '}
                        <strong>
                            Sales report
                        </strong>
                    </div>

                    <h1>
                        Sales report
                    </h1>

                    <p>
                        Outlet information and table QR information
                    </p>
                </div>

                <div className="report-actions">
                    <div className="report-tabs">
                        <button className="active">
                            Today
                        </button>

                        <button>
                            Week
                        </button>

                        <button>
                            Month
                        </button>
                    </div>

                    <button className="btn-export">
                        <DownloadSimple size={18} />
                        Export CSV
                    </button>
                </div>
            </div>

            <div className="stats-grid">
                <div className="stat-card">
                    <span>
                        TOTAL REVENUE
                    </span>

                    <h2>
                        RM4,250.80
                    </h2>

                    <div className="trend positive">
                        <ArrowUp size={14} />
                        18.2%
                    </div>
                </div>

                <div className="stat-card">
                    <span>
                        TOTAL ORDERS
                    </span>

                    <h2>142</h2>

                    <div className="trend positive">
                        <ArrowUp size={14} />
                        41 orders
                    </div>
                </div>

                <div className="stat-card">
                    <span>
                        AVG ORDER VALUE
                    </span>

                    <h2>
                        RM87.60
                    </h2>

                    <div className="trend negative">
                        <ArrowDown size={14} />
                        1.8%
                    </div>
                </div>
            </div>

            <div className="report-grid">
                <div className="report-card">
                    <div className="report-card__header">
                        Revenue trend
                    </div>

                    <div className="chart-wrapper">
                        <div className="chart-y-axis">
                            <span>
                                40K
                            </span>
                            <span>
                                32K
                            </span>
                            <span>
                                24K
                            </span>
                            <span>
                                16K
                            </span>
                            <span>
                                8K
                            </span>
                            <span>
                                0
                            </span>
                        </div>

                        <div className="chart-area">
                            <div className="chart-lines">
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>

                            <svg
                                viewBox="0 0 700 260"
                                preserveAspectRatio="none"
                                className="chart-svg"
                            >
                                <path
                                    d="M40 60 L140 110 L240 118 L340 55 L440 92 L540 98 L640 82"
                                    fill="none"
                                    stroke="#15b6cd"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                />

                                <path
                                    d="M40 60 L140 110 L240 118 L340 55 L440 92 L540 98 L640 82 L640 260 L40 260 Z"
                                    fill="rgba(21,182,205,0.15)"
                                />
                            </svg>

                            <div className="chart-labels">
                                <span>
                                    30 Apr
                                </span>
                                <span>
                                    1 May
                                </span>
                                <span>
                                    2 May
                                </span>
                                <span>
                                    3 May
                                </span>
                                <span>
                                    4 May
                                </span>
                                <span>
                                    5 May
                                </span>
                                <span>
                                    6 May
                                </span>
                            </div>

                            <div className="chart-legend">
                                <div className="chart-dot" />
                                Revenue
                            </div>
                        </div>
                    </div>
                </div>

                <div className="report-card">
                    <div className="report-card__header">
                        Daily breakdown
                    </div>

                    <div className="breakdown-table">
                        <div className="breakdown-head">
                            <span>
                                DATE
                            </span>
                            <span>
                                ORDERS
                            </span>
                            <span>
                                NET REVENUE
                            </span>
                            <span>
                                AVG ORDER VALUE
                            </span>
                        </div>

                        {breakdown.map(
                            (
                                item,
                                index
                            ) => (
                                <div
                                    className="breakdown-row"
                                    key={index}
                                >
                                    <span>
                                        {
                                            item.date
                                        }
                                    </span>

                                    <span>
                                        {
                                            item.orders
                                        }
                                    </span>

                                    <span>
                                        {
                                            item.revenue
                                        }
                                    </span>

                                    <span>
                                        {
                                            item.avg
                                        }
                                    </span>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>

            <div className="report-card">
                <div className="report-card__header">
                    Top selling items
                </div>

                <div className="top-items-grid">
                    {topItems.map(
                        (
                            item,
                            index
                        ) => (
                            <div
                                className="top-item"
                                key={index}
                            >
                                <div className="top-item__left">
                                    <div className="top-item__rank">
                                        {
                                            item.rank
                                        }
                                    </div>

                                    <img
                                        src={
                                            item.image
                                        }
                                        alt={
                                            item.name
                                        }
                                    />

                                    <div className="top-item__content">
                                        <h4>
                                            {
                                                item.name
                                            }
                                        </h4>

                                        <p>
                                            {
                                                item.category
                                            }{' '}
                                            ・{' '}
                                            {
                                                item.price
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="top-item__right">
                                    <h5>
                                        {
                                            item.revenue
                                        }
                                    </h5>

                                    <span>
                                        {
                                            item.sold
                                        }
                                    </span>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}